import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import Unibrow from 'js/design_system/Unibrow';

import ChurnIllustration from './illustrations/churn_illustration.svg';

import type { ChurnedUserReactivationUnibrowProps } from './types';

export default function ChurnedUserReactivationUnibrow({
  offer,
  value,
  mentions,
}: ChurnedUserReactivationUnibrowProps) {
  const dismissibleName = 'ChurnedUserReactivationUnibrow';

  const handleClick = () => {
    window.location.href = routes.checkout_path({
      feature: 'churned_user_reactivation',
      trigger: 'reactivate_unibrow',
    });
  };

  let text;
  let buttonText;
  if (offer === 'discount') {
    text = mentions
      ? `See your ${mentions} new Mentions, ${value} OFF Premium`
      : `Accelerate your research, ${value} OFF Premium`;
    buttonText = `Reactivate Premium, ${value} OFF`;
  } else {
    text = mentions
      ? `See your ${mentions} new Mentions for just ${value}`
      : `Accelerate your research with Premium for just ${value}`;
    buttonText = `Reactivate Premium for ${value}`;
  }

  return (
    <Unibrow
      dismissibleName={dismissibleName}
      text={text}
      primaryButton={{
        text: buttonText,
        onClick: handleClick,
        iconRight: 'arrow_forward',
        trackClick: {
          source: 'churned_user_reactivation_unibrow',
        },
      }}
      icon={<ChurnIllustration size={40} />}
    />
  );
}
